import axios from "axios";
import { LogLevel } from "@azure/msal-browser";
import { API_HOST,REDIRECT_URI } from "./config"; // Import the host URL from the config file..

export let msalConfig = {};

// Function to fetch the configuration values from thebackend
export const fetchConfig = async () => {
  try {
    const clientIdResponse = await axios.get(
      `${API_HOST}/hantera/azureclientId`
    );
    const authorityResponse = await axios.get(
      `${API_HOST}/hantera/azureauthority`
    );
    const secretResponse = await axios.get(
      `${API_HOST}/hantera/azuresecretkey`
    );
    // const redirectUriResponse = await axios.get(
    //   `${API_HOST}/hantera/redirectURL`
    // );

    const clientIdSecret = clientIdResponse.data;
    const authority = authorityResponse.data;
    const secretkey = secretResponse.data;
    const redirectUri = REDIRECT_URI; // Fetch from config.js
    //const redirectUri = redirectUriResponse.data;  

    // Update msalConfig dynamically with the fetched values
    msalConfig = {
      auth: {
        clientId: clientIdSecret,
        authority: authority,
        redirectUri: redirectUri,
        secretKey: secretkey,
        apihost: API_HOST,
      },
      cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
      },
      system: {
        loggerOptions: {
          loggerCallback: (level, message, containsPii) => {
            if (containsPii) {
              return;
            }
            switch (level) {
              case LogLevel.Error:
                console.error(message);
                return;
              case LogLevel.Info:
                console.info(message);
                return;
              case LogLevel.Verbose:
                console.debug(message);
                return;
              case LogLevel.Warning:
                console.warn(message);
                return;
              default:
                return;
            }
          },
        },
      },
    };
  } catch (error) {
    console.error("Error fetching clientIdSecret:", error);
  }
};
export const loginRequest = {
  scopes: ["User.Read"],
};
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};


